export const formatCurrencyNumber = (value?: number): string => `${(value ?? 0).toLocaleString("vi-VN")} VNĐ`;
